import type { OAuthProvider } from '@/shared/config/routes';
import type { SignInLinkData } from '../types';
import { EmailSignInForm } from './email-sign-in-form';
import { LegalNote } from './legal-note';
import { OAuthButtons } from './oauth-buttons';

type SignInFormViewProps = {
  onOAuth: (provider: OAuthProvider) => void;
  onSent: (link: SignInLinkData) => void;
};

export function SignInFormView({ onOAuth, onSent }: SignInFormViewProps) {
  return (
    <>
      <div data-enter="" className="flex flex-col gap-2">
        <h1 className="font-semibold text-title-lg">Sign in to Macswarm</h1>
        <p className="text-muted">
          New here? The same steps create your account, with 3 free Pod-hours.
        </p>
      </div>
      <OAuthButtons onStart={onOAuth} />
      <div
        data-enter=""
        className="grid grid-cols-[1fr_auto_1fr] items-center gap-3 text-control text-muted before:h-px before:bg-line after:h-px after:bg-line"
      >
        <span>or with email</span>
      </div>
      <EmailSignInForm onSent={onSent} />
      <LegalNote />
    </>
  );
}
